export default __webpack_public_path__ + "static/media/arrow-right.21f1739e.svg";